module.exports = __webpack_public_path__ + "static/media/S3N1-2.4a67f49d.svg";